import React from "react";
import SynPhoto from "../../assets/images/SynPhoto.png";
import texture from "../../assets/images/Texture.png";
import { useWindowSize } from "../../hooks/useWindowSize";
import CompanySlider from "../LandingPage/CompanySlider";
import { useNavigate } from "react-router-dom";
import Prinx from "../../assets/images/prinx.png";
import { Link } from "react-router-dom";

const SyntheticMasthead: React.FC = () => {
  const { isMobile } = useWindowSize();
  const navigate = useNavigate();

  // Load the WaitKit script when component mounts

  const handleJoinWaitlist = () => {
    window.open("https://app.prinx.io/#/discover", "_blank");
  };

  return (
    <section className="relative pb-16 overflow-hidden">
      {/* Prinx Logo in top left corner */}
      <div className="absolute top-16 left-12 z-20">
        <img src={Prinx} alt="Prinx Logo" className="w-32 h-auto filter brightness-0 invert" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 items-center min-h-screen px-8 lg:px-12 relative lg:-top-10 pt-20">
        {/* Main Content - adjusted with padding-top to account for the fixed header */}
        <div className="flex flex-col items-center lg:items-start justify-center text-center lg:text-left mb-12 pt-8">
          <div className="mb-4 mt-4">
            <div
              style={{
                background: "linear-gradient(90deg, #9386F4, #436FE6)",
                padding: "1px",
                borderRadius: "20px",
                display: "inline-block",
                margin: "0 auto"
              }}
            >
              <div
                style={{
                  background: "#131C34",
                  borderRadius: "20px",
                  padding: "4px 16px",
                  fontSize: "18px"
                }}
              >
                Coming Soon
              </div>
            </div>
          </div>
          <h1 className="pt-3 text-3xl md:text-4xl lg:text-5xl mb-6 tracking-widest px-0 md:px-0">
            The next big markets will be driven by culture.
          </h1>
          <p className="text-white text-lg md:text-xl lg:text-2xl pt-2 mb-8 max-w-xl pr-0 md:pr-8 pb-2 text-center md:text-left">
            Soon you will be able to long and short songs, artists, video games and more.
          </p>
          <button
            onClick={handleJoinWaitlist}
            style={{
              background: "linear-gradient(90deg, #436FE7, #9386F4)",
              position: "relative",
              top: isMobile ? 20 : 0
            }}
            className="text-white px-6 py-3 rounded-full text-lg hover:opacity-90 transition-opacity duration-300 relative sm:-top-10"
          >
            See Testnet
          </button>
        </div>
        {/* Right Column: Image */}
        <div className="relative lg:h-[530px] flex items-center justify-center mb-48 lg:mb-0 pt-6 md:pt-0">
          <img
            src={SynPhoto}
            alt="Dashboard Placeholder"
            className="transform rounded-xl shadow-lg lg:rounded-none lg:rounded-tl-2xl lg:rounded-bl-2xl lg:border-r-0 lg:h-full lg:w-auto lg:object-cover lg:object-left lg:translate-x-24"
          />
        </div>
      </div>
      {/* Bottom Section */}
    </section>
  );
};

export default SyntheticMasthead;
